import React from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const CustomInput = ({
    label,
    name,
    type = "text",
    formik,
    tooltip,
    placeholder = "",
    className = "",
    required = false,
    min,
    max,
    disabled
}) => {
    const hasError = formik.touched[name] && formik.errors[name];

    return (
        <div className={`mb-3 ${className}`}>
            <div className="d-flex align-items-center mb-2">
                <label className="form-label mb-0" htmlFor={name}>
                    {required && <span className="text-danger">*</span>} {label}
                </label>
                {tooltip && (
                    <Tooltip title={tooltip}>
                        <InfoCircleOutlined className="text-muted" />
                    </Tooltip>
                )}
            </div>
            <div className="position-relative">
                <input
                    id={name}
                    className={`form-control ${hasError ? "is-invalid" : ""}`}
                    type={type}
                    name={name}
                    value={formik.values[name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder={placeholder}
                    min={min}
                    max={max}
                    style={{ fontSize: "0.875rem" }}
                    disabled={disabled}
                />
                {hasError && (
                    <div className="text-danger" style={{ fontSize: "0.875rem" }}>
                        {formik.errors[name]}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomInput;
